import { Card, Col, Row } from "antd";
import { FC, useMemo } from "react";
import { useGetSupplies } from "~/services/supply";
import { StatusStock } from "~/utils/constants";

type Props = {};

export const OverviewSupplies: FC<Props> = () => {
  const { data: supplies } = useGetSupplies({});
  const { data: lowStockSupplies } = useGetSupplies({
    statusStock: StatusStock.LOW_STOCK,
  });

  const countCategories = useMemo(() => {
    if (!supplies) return 0;
    const categories = new Set(
      supplies.items.map((supply) => supply.category)
    );
    return categories.size;
  }, [supplies]);

  return (
    <Row gutter={16}>
      <Col span={6}>
        <Card>
          <p className="text-gray-500 mb-1">Total Items</p>
          <h3 className="text-2xl font-semibold">{supplies?.meta.totalItems ?? 0}</h3>
          <p className="text-sm text-gray-500 mt-1">
            Across {countCategories} categories
          </p>
        </Card>
      </Col>
      <Col span={6}>
        <Card>
          <p className="text-gray-500 mb-1">Total Value</p>
          <h3 className="text-2xl font-semibold">$0</h3>
          <p className="text-sm text-gray-500 mt-1">Current inventory</p>
        </Card>
      </Col>
      <Col span={6}>
        <Card>
          <p className="text-gray-500 mb-1">Low Stock Items</p>
          <h3 className="text-2xl font-semibold text-red-600">
            {lowStockSupplies?.meta.totalItems ?? 0}
          </h3>
          <p className="text-sm text-red-500 mt-1">Need reordering</p>
        </Card>
      </Col>
      <Col span={6}>
        <Card>
          <p className="text-gray-500 mb-1">Pending Orders</p>
          <h3 className="text-2xl font-semibold">0</h3>
          <p className="text-sm text-gray-500 mt-1">Expected: Mar 15, 2023</p>
        </Card>
      </Col>
    </Row>
  );
};
